export default __webpack_public_path__ + "static/media/lp-logo-new.0e858a51.png";